import React, { useState, useEffect } from 'react';
import { ActionHeader, Gutter, GutterCap, Header } from '../../../../generic/AsTable/Standard';
import DataRow from './DataRow';

const DataRows = ({
    data = [],
    onChange,
    rowHeight,
    visibleRows,
    readOnly,
    onEdit,
    onDelete,
    displayField,
    onLinkClick
}) => {
    const [scrollPx, setScrollPx] = useState(0);
    const [highlightedRow, setHighlightedRow] = useState(-1);
    const [sumEntity, setSumEntity] = useState({ name: 'Total' });
    const colWidths = [140, 100, 110]; // ASSP-7703 last col expanded for scrollbar
    const radioTextStyle = {
        marginLeft: 5.5,
        marginRight: 8,
        fontSize: 15
    };

    // ASSP-7703 Redundant as the data have a totals row sumEntity - need to pad the data 
    // rows before adding sumEntity
    //
    const padWithEmptyRows = () => {
        const retVal = [];
        for (let i = data.length + 2; i < visibleRows; i++) {
            retVal.push(
                <DataRow
                    key={i}
                    index={i}
                    scrollPx={scrollPx}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    hideEditable={true}
                    colWidths={colWidths}
                />
            );
        }
        return retVal;
    };

    useEffect(() => {
        sumEntity.bookedImpacts = data.reduce((b, a) => {
            return b + a.bookedImpacts;
        }, 0);
        sumEntity.deliveredImpacts = data.reduce((b, a) => {
            return b + a.deliveredImpacts;
        }, 0);
        sumEntity.scheduledImpacts = data.reduce((b, a) => {
            return b + a.scheduledImpacts;
        }, 0);
        sumEntity.bookedSpots = data.reduce((b, a) => {
            return b + a.bookedSpots;
        }, 0);
        sumEntity.deliveredSpots = data.reduce((b, a) => {
            return b + a.deliveredSpots;
        }, 0);
        sumEntity.scheduledSpots = data.reduce((b, a) => {
            return b + a.scheduledSpots;
        }, 0);
        sumEntity.bookedPrice = data.reduce((b, a) => {
            return b + a.bookedPrice;
        }, 0);
        sumEntity.scheduledPrice = data.reduce((b, a) => {
            return b + a.scheduledPrice;
        }, 0);
        sumEntity.deliveredPrice = data.reduce((b, a) => {
            return b + a.deliveredPrice;
        }, 0);

        setSumEntity({ ...sumEntity });
    }, [data]);

    // ASSP-7703 Moved to here to get tableDataLength for DataRow visibleRows which somehow
    // controls the size of the scrolling div with the datarows including totals row
    //
    const tableData = [
        ...data.sort((a, b) => {
            return a.name > b.name ? 1 : -1;
        }),
        sumEntity,
    ];
    const totalScrollingRows = tableData.length;
    console.log('DataRows tabledata', tableData);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 99 }}>
                <Header
                    area={'timeSlotH'}
                    style={{ borderWidth: '1px 1px 1px 1px', height: 40, width: colWidths[0] }}
                    scrollPx={scrollPx}
                >
                    {window.translate('')}
                </Header>
                <Header area={'bookedH'} scrollPx={scrollPx} style={{ height: 40, width: colWidths[1] }}> {/* ASSP-7703 match DataRow */}
                    {window.translate('Booked')}
                </Header>
                <Header area={'deliveredH'} scrollPx={scrollPx} style={{ height: 40, width: colWidths[1] }}> {/* ASSP-7703 match DataRow */}
                    {window.translate('Delivered')}
                </Header>
                <Header area={'scheduledH'} scrollPx={scrollPx} style={{ height: 40, width: colWidths[1] }}> {/* ASSP-7703 match DataRow */}
                    {window.translate('Scheduled')}
                </Header>
                <Header area={'trackingH'} scrollPx={scrollPx} style={{ height: 40, width: colWidths[2] }}> {/* ASSP-7703 match DataRow */}
                    {window.translate('Tracking')}
                </Header>
            </div>

            {tableData.map((entity, i) => (
                <DataRow
                    key={i}
                    index={i}
                    entity={entity}
                    scrollPx={scrollPx}
                    onChange={onChange}
                    onHover={setHighlightedRow}
                    isHighlighted={highlightedRow === i}
                    rowHeight={rowHeight}
                    visibleRows={totalScrollingRows} // ASSP-7703 was visibleRows + 10 and hiding most of the data 
                    readOnly={readOnly}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onLinkClick={onLinkClick}
                    colWidths={colWidths} // ASSP-7703 use colWidths to match headers
                    displayField={displayField}
                />
            ))}

            {/* <Gutter
                scrollPx={scrollPx}
                onScroll={setScrollPx}
                scrollableLength={data.length * rowHeight}
                maxVisibleLength={visibleRows * rowHeight}
            /> */}

            {/* padWithEmptyRows() ASSP-7703 removed for consistency with station breakdown */}
        </div>
    );
};

export default DataRows;
